import axios, { getAuthHeaders } from "./config";
export default {
    store: function(action) {
        return axios.post("/actions", action, {
            headers: getAuthHeaders(),
        });
    },
    get: function() {
        return axios.get('/actions', {
            headers: getAuthHeaders(),
        });
    },
    update: function(data) {
        return axios.put(`/actions/${data.id}`, data, {
            headers: getAuthHeaders(),
        });
    },
    delete: function(actionID) {
        return axios.delete(`/actions/${actionID}`, {
            headers: getAuthHeaders(),
        });
    },
}